export function validateViewField(
  name,
  value,
  shouldSetState = false,
  setStateCallback
) {
  if (typeof value === "undefined") {
    value = this.state.fields[name];
  }

  const valid = value ? this._fieldValidator(name, value) : null;

  if (shouldSetState === true) {
    const validFields = { ...this.state.validFields };
    if (valid !== null) {
      validFields[name] = valid;
    } else {
      delete validFields[name];
    }

    this.setState({ validFields }, setStateCallback);
  }

  return valid;
}

export function onViewFieldChange(
  name,
  value,
  manualValidation = null,
  callback = null
) {
  let valid = false;
  if (manualValidation != null) {
    valid = manualValidation;
  } else {
    valid = validateViewField.call(this, name, value);
  }

  const newStateProps = {
    fields: { ...this.state.fields, [name]: value }
  };

  newStateProps.validFields = {
    ...this.state.validFields,
    [name]: valid !== false ? valid : null
  };
  this.setState(newStateProps, callback);
}

export function onViewFieldBlur(name, callback, skipValidation) {
  if (skipValidation) {
    validateViewField.call(this, name, undefined, false);
  } else {
    validateViewField.call(this, name, undefined, true, callback);
  }
}



// WEBPACK FOOTER //
// ./src/routes/Cob/Cob.helpers.js